import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ErrorService } from '@services/error.service';

@Component({
  selector: 'app-unexpected-error',
  templateUrl: './unexpected-error.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UnexpectedErrorComponent {
  errorService = inject(ErrorService);
  closePopup() {
    this.errorService.closeError();
  }
}
